import React from "react";
import { useNavigate } from "react-router-dom";
import { ShieldAlert, ArrowLeft } from "lucide-react";

const InactiveUser = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#DFF4FF] via-[#F6FBFF] to-[#EAF7FF] flex items-center justify-center px-6">
      <div className="w-full max-w-lg bg-white rounded-3xl shadow-lg border border-sky-100 p-10">
        {/* ICON */}

        <div className="flex justify-center mb-6">
          <div className="h-20 w-20 rounded-3xl bg-sky-50 flex items-center justify-center shadow-sm">
            <ShieldAlert
              size={36}
              className="text-sky-600"
            />
          </div>
        </div>

        {/* TITLE */}

        <h1 className="text-3xl font-semibold text-slate-800 text-center mb-3">
          Account Inactive
        </h1>

        {/* MESSAGE */}

        <p className="text-slate-500 text-center leading-7 mb-8">
          Your account is currently inactive and access is not available.
          Please contact the administrator for assistance.
        </p>

        {/* INFO BOX */}

        <div className="bg-sky-50 border border-sky-100 rounded-2xl px-4 py-4 mb-8">
          <p className="text-sm text-slate-600 text-center">
            If you believe this is incorrect, reach out to your administrator.
          </p>
        </div>

        {/* BUTTON */}

        <button
          onClick={() => navigate("/")}
          className="w-full flex items-center justify-center gap-2 bg-sky-600 text-white py-3 rounded-2xl font-medium
                     transition-all duration-300 hover:bg-sky-700"
        >
          <ArrowLeft size={18} />
          Back to Home
        </button>
      </div>
    </div>
  );
};

export default InactiveUser;